// Lib
import { oc } from "ts-optchain";

// Vue
import { mapGetters } from "vuex";

// Icons
import { faCheckCircle } from "@fortawesome/free-regular-svg-icons";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

// Services
import { EventTrackingService, ObjectUtil } from "@/services";

// Types
import { IFreeFreightRuleDto } from "@/types";
import { IShoppingCartContext } from "../../Types";

export default {
  name: "CartFreight",
  components: {
    FontAwesomeIcon,
  },
  props: {
    context: {
      type: Object,
      default: () => {
        return ObjectUtil.createInstance<IShoppingCartContext>();
      },
    },
  },
  data: () => ({
    alertIcon: faExclamationCircle,
    successIcon: faCheckCircle,
  }),
  computed: {
    ...mapGetters(["getContentItem"]),

    otherFreightRules() {
      return oc(this.context as IShoppingCartContext).cartData.NonOrdersFreightRules([]);
    },

    orderFreightRules() {
      return oc(this.context as IShoppingCartContext).cartData.OrdersCategoryFreightRules([]);
    },

    showFreightRules() {
      return this.otherFreightRules.length > 0 || this.orderFreightRules.length > 0;
    },
  },

  mounted() {
    const freightRules = this.otherFreightRules.concat(this.orderFreightRules);

    freightRules.forEach((rule: IFreeFreightRuleDto) => {
      EventTrackingService.trackEvent({
        action: "Shopping Cart",
        category: "Freight Schedule",
        label: `${rule.ScheduleId}`,
        value: rule.MeetsPolicy ? 1 : 0,
      });
    });
  },

  methods: {
    getClassForRule(rule: IFreeFreightRuleDto) {
      return {
        "cart-rule": true,
        "cart-border-success": rule.MeetsPolicy,
        "cart-border-alert": !rule.MeetsPolicy,
      };
    },

    getIconClassForRule(rule: IFreeFreightRuleDto) {
      return {
        "fa-2x": true,
        "rule-icon": true,
        "cart-text-success": rule.MeetsPolicy,
        "cart-text-alert": !rule.MeetsPolicy,
      };
    },

    getIconForRule(rule: IFreeFreightRuleDto) {
      return rule.MeetsPolicy ? this.successIcon : this.alertIcon;
    },
  },
};
